import React, { useRef } from 'react'
import '../css/popupbg.css';

const PopupBg = ({ closeModal, opacity, children }) => {
    const popupRef = useRef();

    const closePopupBg = e => {
        if(popupRef.current === e.target){
            closeModal();
        }
    }

  return (
    <div className={"PopupBg "+opacity} ref={popupRef} onClick={closePopupBg}>
        {children}
    </div>
  )
}

export default PopupBg